/**
 * Shared CSS-in-JS style objects for the Instructions modal and the Tutorial Reference Rail.
 *
 * Lives in its own file (not InstructionsSections.tsx) because react-refresh only HMR-updates
 * files that export components-only — mixing constant exports with component exports breaks
 * fast-refresh for the components in that file.
 */
import { FONT_RUNE, theme } from "./theme";

export const paragraph: React.CSSProperties = {
  margin: "0 0 10px 0",
  fontSize: 14,
  lineHeight: 1.55,
  opacity: 0.92,
};

export const list: React.CSSProperties = {
  margin: "0 0 10px",
  paddingLeft: 18,
  fontSize: 14,
  lineHeight: 1.55,
  opacity: 0.92,
};

export const ctaPrimary: React.CSSProperties = {
  padding: "11px 16px",
  background: theme.accent,
  color: theme.bg,
  border: `1px solid ${theme.accent}`,
  borderRadius: 6,
  fontFamily: FONT_RUNE,
  fontSize: 14,
  letterSpacing: 1,
  cursor: "pointer",
  textAlign: "center",
};

export const ctaSecondary: React.CSSProperties = {
  padding: "10px 16px",
  background: theme.bg,
  color: theme.parchment,
  border: `1px solid ${theme.inkSoft}`,
  borderRadius: 6,
  fontFamily: FONT_RUNE,
  fontSize: 14,
  letterSpacing: 1,
  cursor: "pointer",
  textAlign: "center",
};
